import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { applyColor } from '~src/style/ColorService';

import { cssClass } from '../../style';

const cssPrefix = 'AllUserIdentitiesSubspace';

export namespace AllUserIdentitiesSubspaceStyles {

  export const MastheadArea = cssClass(cssPrefix, 'masthead-area', {
    paddingTop: TabStyles.Spacing.LargeSpace,
    paddingRight: TabStyles.Spacing.ExtraLargeSpace,
    paddingLeft: TabStyles.Spacing.ExtraLargeSpace,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'baseline',
  });

  export const SpaceHeaderContent = cssClass(cssPrefix, 'space-header-content', {
    marginTop: TabStyles.Spacing.MediumSpace,
    marginBottom: TabStyles.Spacing.MediumSpace,
    width: '100%',
  });

  export const SpaceHeaderText = cssClass(cssPrefix, 'space-header-text', {
    fontWeight: 'normal',
    fontSize: TabStyles.Typography.Sizing.XXLarge,
    marginRight: TabStyles.Spacing.ExtraLargeSpace
  });

  export const SpaceSubHeaderText = cssClass(cssPrefix, 'space-subheader-text', {
    fontWeight: 'normal',
    fontSize: TabStyles.Typography.Sizing.XLarge,
    marginRight: TabStyles.Spacing.LargeSpace
  });

  export const ToolTipHeaderText = cssClass(cssPrefix, 'tool-tip-header-text', {
    fontWeight: 'bold',
    fontSize: TabStyles.Typography.Sizing.Large,
    marginBottom: TabStyles.Spacing.SmallSpace,
    marginLeft: TabStyles.Spacing.SmallSpace,
    display: 'flex',
    flexDirection: 'column',
  });

  export const ToolTipContent = cssClass(cssPrefix, 'tool-tip-content', {
    fontWeight: 'normal',
    fontSize: TabStyles.Typography.Sizing.Small,
    marginBottom: TabStyles.Spacing.LargeSpace,
    marginLeft: TabStyles.Spacing.SmallSpace,
    display: 'flex',
    flexDirection: 'column',
  });

  export const FailureTypeButtonGroup = cssClass(cssPrefix, 'failure-type-button-group', {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop:  TabStyles.Spacing.SmallSpace,
    $nest: {
      '&>*': {
      },
      '&>*:last-child': {
        marginLeft: 'auto',
      },
      '&>*:first-child': {
      }
    }
  });


  const FailureTypeItemCommon: React.CSSProperties = {
    color: applyColor(DesignTokens.color.font.default.secondary, CommonStyles.Colors.Grey102),
    display: 'flex',
    flexDirection: 'column',
    paddingTop: TabStyles.Spacing.MediumSpace,
  };

  export const FailureTypeItem = cssClass(cssPrefix, 'failure-type-item', {
    ...FailureTypeItemCommon,
  });

  export const FailureTypeItemSelectedOption = cssClass(cssPrefix, 'failure-type-item', {
    ...FailureTypeItemCommon,
    backgroundColor: applyColor(DesignTokens.color.component.background.neutral.default.active, CommonStyles.Colors.Grey235),
  });

  const FailureTypeItemLabelCommon: React.CSSProperties = {
    paddingTop: TabStyles.Spacing.SmallSpace,
    fontWeight: 'normal',
    textAlign: 'center',
    fontSize: TabStyles.Typography.Sizing.XLarge,
    paddingRight: TabStyles.Spacing.LargeSpace,
    paddingLeft: TabStyles.Spacing.LargeSpace,
};

  export const FailureTypeItemLabel: React.CSSProperties = {
    ...FailureTypeItemLabelCommon,
    color: applyColor(DesignTokens.color.icon.default.discrete, CommonStyles.Colors.DiscreteBlue),
};

  export const FailureTypeItemLabelSelectedOption: React.CSSProperties = {
    ...FailureTypeItemLabelCommon,
    color: applyColor(DesignTokens.color.font.default.default, CommonStyles.Colors.NormalTextColor),
};

  export const FailureTypeItemCount: React.CSSProperties = {
    marginTop: TabStyles.Spacing.LargeSpace,
    fontWeight: 'normal',
    fontSize: '28px',
    textAlign: 'center',
    paddingBottom: TabStyles.Spacing.MediumSpace,
    paddingRight: TabStyles.Spacing.LargeSpace,
    paddingLeft: TabStyles.Spacing.LargeSpace,
  };

  const FailureTypeBottomBarCommon: React.CSSProperties = {
    height: '3px',
    width: '100%',
  };

  export const FailureTypeBottomBar: React.CSSProperties = {
    ...FailureTypeBottomBarCommon,
    backgroundColor: applyColor(DesignTokens.color.component.background.neutral.default.active, CommonStyles.Colors.Grey230),
  };

  export const FailureTypeBottomBarSelectedOption: React.CSSProperties = {
    ...FailureTypeBottomBarCommon,
    backgroundColor: applyColor(DesignTokens.color.elevation.border.default.subtle, CommonStyles.Colors.NormalTextColor),
  };

  export const ProgressBar = cssClass(cssPrefix, 'progress-bar', {
    marginBottom: 8,
  });
}
